

































import { useCustomersStore } from "@/store/useCustomersStore";
import { BFormCheckbox, BFormGroup, BFormInput } from "bootstrap-vue";
import { storeToRefs } from "pinia";

export default {
    components: { BFormInput, BFormGroup, BFormCheckbox },
    setup() {
        const { customerSettings, editableCustomerSettings } = storeToRefs(useCustomersStore());

        editableCustomerSettings.value.push("noticeEnabled");
        editableCustomerSettings.value.push("noticeText");

        return {
            customerSettings,
        };
    },
};
